const state = {
    statuses: [
        { name: '', id: 0 },
       /* { name: 'Заготовка под ордер', id: -1, type: "new" },*/
        { name: 'Укладений', id: 10, type: "concluded", nameAlt: 'Укладені' },
        { name: 'Заявлений', id: 5, type: "declared", nameAlt: 'Заявлені',},
        { name: 'Чернетка', id: 1, type: "draft", nameAlt: 'Чернетка', },
        { name: 'Прострочений', id: 2, type: "overdue", nameAlt: 'Прострочені' },
        { name: 'Розірваний', id: 6, type: "terminated", nameAlt: 'Розірвані' },
        { name: 'Припинений', id: -10, type: "canceled", nameAlt: 'Припинені'},
    ],
};

const getters = {
    ORDER_STATUSES: state => state.statuses
};

export default {
    state,
    getters
};
